export const subscription = {
	title: "Choix de l'abonnement",
	action: {
		label: "Je confirme mon choix",
		title: "Vous confirmez votre choix"
	},
	'no-choice': "Je choisis plus tard",
}
